module.exports = __webpack_public_path__ + "img/img_paperMaterial1_test.caf71d0e.png";